import React from 'react';
import { CheckIcon } from 'lucide-react';
import { boardReadiness } from '../data/profile';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function BoardReadiness() {
  return <section aria-label="Board readiness" className="w-full border-t border-line bg-white py-20 lg:py-24" data-id="element-100" data-mp="12h7xzxusq0zu">
      <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-101" data-mp="xiy0hgllmob2">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.36fr_0.64fr] lg:gap-20" data-id="element-102" data-mp="skcxxaivjsjg">
          <Reveal data-id="element-103" data-mp="nsuyiqwi200l">
            <div data-id="element-104" data-mp="nsbp5ykx0jy6">
              <SectionLabel data-id="element-105" data-mp="nrtn2lbknbic">Board Readiness</SectionLabel>
              <h2 className="mt-6 font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-navy sm:text-[38px]" data-id="element-106" data-mp="jr9nzc7ftxtk">
                What Kevin brings to a board table
              </h2>
              <p className="mt-5 text-[15px] leading-[1.7] text-charcoal-muted" data-id="element-107" data-mp="9u4z34m7jo92">
                Committee-level fluency in the areas boards are most often asked to oversee but least
                often staffed to evaluate.
              </p>
            </div>
          </Reveal>

          <ul className="grid grid-cols-1 gap-x-10 gap-y-1 sm:grid-cols-2" data-id="element-108" data-mp="z050m2sj2zy9">
            {boardReadiness.map((item, index) => <Reveal key={item} delay={index * 0.04} as="li" data-id="element-109" data-mp="kc0f6r23cabs" data-mpi={index}>
                <div className="flex items-start gap-3 border-b border-line py-5 text-[15px] leading-snug text-charcoal" data-id="element-110" data-mp="pabnuygngesf">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-metal" aria-hidden="true" data-id="element-111" data-mp="1czcwomte9ry8" />
                  {item}
                </div>
              </Reveal>)}
          </ul>
        </div>
      </div>
    </section>;
}